import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";

export type NotificationSubject = Extract<
  OpenAPI.PUT<"/notifications/interacted">["requestBody"],
  { subject: unknown }
>["subject"];

export const notifications = (api: API) => ({
  get(
    page: number,
    success: (data: OpenAPI.GET<"/notifications">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/notifications?page=${page}`,
      null,
      success,
      fail,
    );
  },
  markAllAsSeen(
    success: (data: OpenAPI.PUT<"/notifications/seen">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("PUT", `/notifications/seen`, null, success, fail);
  },
  markAsInteracted(
    notification: string,
    success: (
      data: OpenAPI.PUT<"/notifications/{id}/interacted">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/notifications/${notification}/interacted`,
      null,
      success,
      fail,
    );
  },
  markAllAsInteracted(
    success: (
      data: OpenAPI.PUT<"/notifications/interacted">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/notifications/interacted`,
      { all: true },
      success,
      fail,
    );
  },
  markSubjectAsInteracted(
    subject: NotificationSubject,
    id: string,
    success: (
      data: OpenAPI.PUT<"/notifications/interacted">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/notifications/interacted`,
      { subject, id },
      success,
      fail,
    );
  },
});
